import React from 'react';
import { isEmpty, isNil } from 'ramda';
import Context from './Context';
import { useDidMount } from '../../use';
import { asserts, network } from '../../../utils';
import api from '../../../config/api';
import useContext from './useLayoutContext';
import FooterContainer from './FooterContainer';
import HeaderContainer from './HeaderContainer';
import MainContainer from './MainContainer';
import PopCircle from './PopCircle';
import VersionChecker from './VersionChecker';
import StickyHeader from './StickyHeader';
import { WebIM } from '../../../webImConfig';
import './style/index.less';

export default ({ children, history }) => {
  const contextValue = useContext();
  const [showSticky, setShowSticky] = React.useState(false);
  const [showSidebar, setShowSidebar] = React.useState(false);

  const logout = async () => {
    const response = await network.get(api.core.logout, { silence: true });
    if (response.success || response.status === 401) {

      // 在退出前保存当前页面地址（用于登录后返回）
      // const currentPath = window.location.pathname + window.location.search;
      // sessionStorage.setItem('loginReturnUrl', currentPath);

      console.log("window.location.pathname", window.location.pathname);
      console.log("window.location.search", window.location.search);

      // 保存完整的路径（包含 /mall_test/）
      const currentPath = window.location.pathname; // 已经是 /mall_test/finance/turnkey
      console.log('退出时保存完整路径:', currentPath);
      sessionStorage.setItem('loginReturnUrl', currentPath);

      contextValue.resetCtxState();
      history.replace('/login');
      // 状态清空后，需要保持菜单
      contextValue.updateMenus();
      localStorage.setItem('login', 'false');
      localStorage.removeItem('b2bmgmt_isUpStorage');
      localStorage.removeItem('kgFromLoginFlag');
      localStorage.removeItem('Authorization');
      localStorage.removeItem('cid');
      localStorage.removeItem('openHomeCount'); // 签到弹窗是否已经打开过首页
      localStorage.removeItem('openEquityCount'); //   会员每日升级弹窗是否在首页已经打开过
      localStorage.removeItem('imUserRespVO');
      localStorage.removeItem('b2bChatFrom');
      localStorage.removeItem('b2bChatType');
      sessionStorage.removeItem('b2b_isScroll');
      sessionStorage.removeItem('b2b_openWebIm');
    }
  };

  useDidMount(() => {
    const { location } = history;
    contextValue.updateBasicConfig();
    contextValue.updateMenus();
    contextValue.updatePrincipal().then((principal) => {
      if (asserts.isExist(principal)) {
        judgementFn(history.location);
        contextValue.updatePermission();
        contextValue.updateDays();
        contextValue.updateOrderType();
        contextValue.updateSignStatus();
        contextValue.updateMemberisWhite();
        contextValue.updateEnvironment();
        contextValue.updateCustomerList();
        contextValue.updateMemberInfo();
        contextValue.updateImInfo().then(() => {
          contextValue.updatehWebImNum();
          if (location && location.pathname !== '/webIm/contact/all') {
            WebIM.login((res) => {
              if (res) {
                WebIM.init(contextValue);
              }
            });
          }
        });
      }
    });
  });

  React.useEffect(() => {
    // 跳转链接时，监听是否显示头
    const unlisten = history.listen((location) => {
      judgementFn(location);
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  });

  const judgementFn = (location) => {
    const shouldVisible = ['/search'].includes(location.pathname);
    setShowSticky(shouldVisible);
    const showSidebar = ['/login', '/register', '/changePwd', '/home'].includes(location.pathname);
    setShowSidebar(!showSidebar);
  };

  return (
    <Context.Provider value={{ ...contextValue, logout, history }}>
      <VersionChecker />
      {showSidebar ? <PopCircle /> : null}
      {showSticky ? <StickyHeader /> : null}
      <HeaderContainer />
      {/* Cause we use react-router-config. nesting routes valid on use the renderRoutes */}
      <MainContainer>{children}</MainContainer>
      <FooterContainer />
    </Context.Provider>
  );
};
